import { IMeasure } from "../../../shared/models/Measure";
import { IScorecardMetadata } from "../../../shared/models/ScorecardMetadata";
import { IUser } from "../../../shared/models/User";
import AppStore from "../../../shared/stores/AppStore";
import { q4FinalRating } from "../../shared/functions/Scorecard";

export function getDepartment(user: IUser, store: AppStore): string {
  const departmentName = store.department.all.find(
    (department) => department.asJson.id === user.department
  )?.asJson.name;
  if (departmentName) {
    return departmentName;
  } else {
    return "-";
  }
}

// export function getFinalWeightedScore(user: IUser, measure: IMeasure[], objective: IObjective[], metaData: IScorecardMetadata[]) {
//     const $metaData = metaData.find((m) => m.uid === user.uid);
//     if ($metaData) {
//         const score = q4FinalRating(measure.filter((m) => m.uid === user.uid), objective.filter((u) => u.uid === user.uid), $metaData);
//         if (score) {
//             return score
//         } else {
//             return 0;
//         }
//     }
// }

export function getFinalRating(
  measures: IMeasure[],
  agreement: IScorecardMetadata
): number | null {
  const $measures = measures;

  //   if (!agreement.assessmentRated) return null;

  const fRating = q4FinalRating($measures);
  return parseFloat(fRating.toFixed(2));
}

export function sortUserAlphabetically(a: IUser, b: IUser): number {
  const [aFirstName, aLastName] = getFirstNameAndLastName(a);
  const [bFirstName, bLastName] = getFirstNameAndLastName(b);
  // Compare last names first
  const firstNameComparison = aFirstName.localeCompare(bFirstName);
  if (firstNameComparison !== 0) return firstNameComparison;

  // If last names are the same, compare first names
  return aLastName.localeCompare(bLastName);
}

function getFirstNameAndLastName(user: IUser): [string, string] {
  const firstName = user.firstName?.toLowerCase();
  const lastName = user.lastName?.toLowerCase();
  const displayName = user.displayName?.toLowerCase();

  if (lastName && firstName) {
    return [firstName, lastName];
  }

  if (displayName) {
    const nameParts = displayName.split(" ");
    if (nameParts.length > 1) {
      return [nameParts[0], nameParts[nameParts.length - 1]];
    }
    return [displayName, ""];
  }

  return ["", ""];
}
